





















































import { Component, Vue } from "vue-property-decorator";
import { Getter } from "vuex-class";
import getActivityType from '@/common/utils/getActivityType';
import getUrlParam from '@/common/utils/getUrlParam';
import { replaceString } from '@/common/utils/dealWithString'
import DashLine from "@/components/common/edit/DashLine.vue";
import CourseDetailIntroList from "./CourseDetailIntroList.vue";
import GroupActivitySection from "@/components/groupType/index/GroupActivitySection.vue";


@Component({
  components: {
    "dash-line": DashLine,
    "coruse-intro-list":CourseDetailIntroList
  }
})
export default class SolitaireCourseDesc extends Vue {
  @Getter("section")  section!: any;
  @Getter("version") version!: string;
  @Getter("leftQuota") leftQuota!: string;
  @Getter("mainTextColor") mainTextColor!: string;
  @Getter("titleSection")  titleSection!: any;
  @Getter("tyTypeParameter") tyTypeParameter!: any
  @Getter("bargainParameter") bargainParameter!: any
  @Getter("showNum") showNum!: boolean;

  templateType: string = getActivityType();
  pageType: string = getUrlParam("type") as string;
  replaceString: Function = replaceString;

  get courseDesc() {
    const { courseDesc, prizeDesc } = this.section;
    if (this.templateType === 'groupType' || this.templateType === 'solitaireType') {
      return courseDesc;
    }
    return prizeDesc;
  }

  get picList(): Array<string> {
    const { prizePic, coursePic } = this.section;
    const imageStr: string = coursePic || prizePic || '';
    return imageStr.split("@").filter((item: string) => {
      return item;
    });
  }
  get prizeNum() {
    if (this.templateType === 'tyType' ) {
      return this.tyTypeParameter.prizeNum;
    }else if ( this.templateType === 'bargainType') {
      return this.bargainParameter.prizeNum;
    }
  }
  get prizeLeftCount() {
    if (this.templateType === 'tyType') {
      const { prizeNum, prizeLeftCount } = this.tyTypeParameter;
      return this.pageType === 'preview' ? prizeNum : prizeLeftCount;
    }
  }
  mounted() {
    const img = document.getElementsByClassName("course-img")[0];
    const timer = window.setTimeout(() => {
      if (img) {
        (img as HTMLImageElement).style.maxHeight = "5000px";
      }
    }, 1000);
  }
}
